import React, { Fragment, useEffect, useState } from "react";
import { Button, Col,Input,Label,Row } from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import requestApiService from '../../services/requestApi.service';
import { handleErrorResponse } from "../../Common/Appcommon";
import Subaccounts from "../../Components/Agency/Subaccounts";
import { encode as base64_encode } from 'base-64';
import Loading from "../../Common/Loading";

const Onboarding = (props) => {
  const { handleSubmit, control, formState: { errors }, clearErrors } = useForm();
  const [step, setStep] = useState(0);
  const [formData, setFormData ] = useState([]);
  const [subStep,  setSubStep] = useState(1);
  const [showLoader,setShowLoader] = useState(false);
  const formFieldConfigs = [
    {
      label: "Business Name ",
      errorlabel : "Please enter your company name.",
      name: "company_name",
      datalabel: 'company_name',
      type: "text",
      description: "",
      placeholder: "Enter your company name",
      isrequired: true,
      isDisabled: false,
    },
    {
      label: "Website URL",
      errorlabel : "Website URL is required",
      name: "web_url",
      datalabel: 'web_url',
      type: "url",
      description: "",
      placeholder: "Enter your website URL",
      isrequired: true,
      isDisabled: false,
    },
    {
      label: "How many customers have you deployed Voice AI solutions to?  ",
      errorlabel : "Number of customers is required.",
      name: "customer_deployed",
      datalabel: 'customer_deployed',
      type: "dropdown",
      description: "",
      placeholder: "Select an option",
      isrequired: true,
      isDisabled: false,
      options :[
        { value: "just_started", label: "Just Started (0)" },
        { value: "acquiring", label: "Acquiring (1 to 10)" },
        { value: "growing", label: "Growing (10 to 25)" },
        { value: "scaling", label: "Scaling (25+)" }
      ],
      allowMulti:false,
    },
    {
      label: "How Did You Find Us?",
      errorlabel : "Please select how you found us.",
      name: "find_us",
      datalabel: 'find_us',
      type: "text",
      description: "",
      placeholder: "e.g., Facebook, Google, Referral",
      isrequired: true,
      isDisabled: false,
    },
  ];
  let brandLogo = process.env.REACT_APP_DARK_LOGO;

  useEffect(() => {
    const getOnboardingStatus = async () => {
      let params = {
        "ENTITY": "AIPROCESSOR",
        "OPERATION": "GET_ONBOARD_STATUS",
      };
      let notallowed = false;
      let formresponse = await requestApiService.processServerRequest(params, "WebV2");
      if (formresponse.issuccess) {
        notallowed = formresponse.data[0] !== undefined && formresponse.data[0] !== null && formresponse.data[0] !== "" ? formresponse.data[0] : false;
      }
      return notallowed;
    };

    (async () => {
      setShowLoader(true)
      let onBoardingStatus = await getOnboardingStatus();
      if (onBoardingStatus) {
        onSkip();
      }
      setShowLoader(false);
    })();
  }, []);

  const nextStep = () =>{
    setStep(step + 1);
  }

  const prevStep = () =>{
    if(step === 2 && subStep !== 1){
      let newStep = subStep - 2;
      setSubStep(newStep);
    }else{
      clearErrors();
      setStep(step -1)
    }
  }

  const onSkip = () =>{
    window.location.hash = "#/overview";
  }

  const onInputChange = async (e,field) => {
    let name = e.target.name;
    let value = e.target.value;
    if (value.trim() === "") {
      value = "";
    }
    e.target.value = value;
    field.onChange(e);
    setFormData((prevData) => ({
        ...prevData,
        [name]: value
    }));
  }

  const onCheckBoxChange = (name,value) =>{
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  }
  const onSelectChange = (name,option) =>{
    setFormData((prevValues) => ({
        ...prevValues,
        [name]: option,
    }));
  }

  const nextSubStep = () => {
    if (subStep !== 3) {
      if(subStep == 1){
        setSubStep(subStep + 2);
      }else {
        setSubStep(subStep + 1);
      }
    }
  };


  const onSubmitAgentDetails = async () => {
     let params = {
          "ENTITY": "AIPROCESSOR",
          "OPERATION": "SAVE_ONBOARD_AGENCY_DETAILS",
          "formData": formData,
      }
      let formresponse = await requestApiService.processServerRequest(params, "WebV2");
      if(formresponse.issuccess){
        nextStep();
      }
      if (!formresponse.issuccess) {
          let errorsMsg = formresponse.errorsMsg ?? '';
          handleErrorResponse(errorsMsg);
          return;
      }
  }

  const getRedirectData = async (SubaccountDetails) =>{
    let data = SubaccountDetails;
    let paramList = JSON.stringify(data);
    paramList= base64_encode(paramList);
    window.location.hash = `#/client/${paramList}`;
  }

  const renderStep0 = () => {
    return (
      <div className="d-flex h-100 justify-content-center align-items-center">
        <Col md="12" className="mx-auto">
          <div className="app-logo-inverse mx-auto mb-3 text-center">
            {brandLogo !== "" && <img src={brandLogo} alt="Brand Logo" />}
          </div>
          <div className="modal-dialog w-100 mx-auto d-flex justify-content-center">
            <div className="modal-content shadow d-flex justify-content-center p-4">
              <div>
                <div className="onboard-title-heading d-flex justify-content-center mt-3">
                  Welcome to Voicemetrics
                </div>
                <div className="onboard-title-desc d-flex justify-content-center mt-3">
                  Your white-labeled AI voice platform to power your agency.  
                </div>
                <div className="d-flex justify-content-center mt-3">
                  <Button onClick={() => { nextStep()}} className="access-account-btn theme-bg-g">
                    Let’s Get Started
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </div>
    );
  };

  const renderStep1 = () =>{
    return(
      <div className="d-flex justify-content-center align-items-center">
        <Col md="12" className="mx-auto">
          <div className="modal-dialog w-100 mx-auto d-flex justify-content-center mt-3">
            <div className="modal-content shadow p-4">
              <div className="d-flex justify-content-center">
                <div className="onboard-title-heading">
                  Your Business Info
                </div>
              </div>
              {formFieldConfigs.map((field, index) => {
                const {label,name,datalabel,type,placeholder,isrequired,isDisabled,autoComplete,options,allowMulti,errorlabel} = field;
                return (
                  <Row key={index} className="mt-3 w-100">
                    <Col md={12} className="field-section">
                      <Label className="form-label" htmlFor={name}>{label}</Label>
                      <Controller
                        name={name}
                        control={control}
                        rules={{
                          required: isrequired ? (formData[datalabel] === undefined || formData[datalabel] === null || formData[datalabel] === "" ? errorlabel : "") : false,
                          ...(type === "url" && {
                            pattern: {
                              value: /^(https:\/\/|www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/[^\s]*)?$/,
                              message: "Please provide a valid URL"
                            }
                          }),
                        }}
                        render={({ field }) => {
                          if(type === "text"){
                            return (
                              <>
                                <Input
                                  {...field}
                                  type="text"
                                  name={name}
                                  id={name}
                                  placeholder={placeholder}
                                  disabled={isDisabled}
                                  autoComplete={autoComplete}
                                  value={formData[datalabel]}
                                  onChange={(e) => {
                                    onInputChange(e,field);
                                  }}
                                  className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
                                />
                              </>
                            )
                          }else if(type === 'dropdown'){
                            return (
                              <>
                                <Select
                                      {...field}
                                      name={name}
                                      id={name}
                                      className="basic-select"
                                      classNamePrefix="sub-select wa-select"
                                      value={formData?.[name] ?? null}
                                      onChange={(selectedOption) => {
                                        field.onChange(selectedOption);
                                        onSelectChange(name, selectedOption);
                                      }}                                      
                                      placeholder={placeholder}
                                      options={options}
                                      isMulti={allowMulti}
                                  />
                              </>
                            )
                          }else if(type === "url"){
                            return (
                              <>
                                <Input
                                  {...field}
                                  type="text"
                                  name={name}
                                  id={name}
                                  placeholder={placeholder}
                                  disabled={isDisabled}
                                  autoComplete={autoComplete}
                                  value={formData[datalabel]}
                                  onChange={(e) => {
                                    onInputChange(e,field);
                                  }}
                                  className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
                                />
                              </>
                            )
                          }else{
                            <>
                              
                            </>
                          }
                        }}
                      />
                      {errors[name] && (
                        <em className="error invalid-feedprevStep">
                          {errors[name].message}
                        </em>
                      )}
                    </Col>
                  </Row>
                );
              })}   
              {/* <Row className="mt-3">
                <Col md={12}>
                  <Controller
                    name={'acceptTerms'}
                    control={control}
                    rules={{ required: formData['acceptTerms'] !== true ? "sss" : false }}
                    render={({ field }) => (
                      <>
                        <label className={'form-label d-flex align-items-center '}>
                            <Input
                              type="checkbox" 
                              checked={formData['acceptTerms'] === true} 
                              className={`onboard-checkbox ${errors['acceptTerms'] ? 'checkbox-is-invalid' : ''}`}
                              onClick={e => {onCheckBoxChange('acceptTerms',e.target.checked)}}
                            />
                            <span className="ms-2 onboard-checkbox-desc"> I understand that the team will disable trial access for clients with invalid business names or website details.</span>
                        </label>
                      </>
                    )}
                  />
                  {errors['acceptTerms'] && (
                        <em className="error invalid-feedprevStep">
                          {/* {errors['acceptTerms'].message} *
                        </em>
                      )}
                </Col>
              </Row> */}
              <Row className="mt-3">
                <Col md= {4}>
                  <Button onClick={handleSubmit(onSubmitAgentDetails)} className="access-account-btn theme-bg-g" >
                    Save and Next
                  </Button>
                </Col>
              </Row>              
            </div>
          </div>
        </Col>
      </div>
    )
  }

  const renderStep2 = () =>{
    return(
      <>
        <div>
            <Row className="mt-2">
              <Col md={12}>
              </Col>
            </Row>
            <Row>
              <div className="d-flex justify-content-center align-items-center mt-5">
                <div className="modal-content shadow p-4 w-50">
                    <div className="onboard-title-heading d-flex justify-content-center mt-1 mb-2">
                        {subStep === 1 && 'Create Account'}
                        {/* {subStep === 2 && 'Sync Resources'} */}
                        {subStep === 3 && 'Trial Settings'}
                    </div>
                    <Subaccounts 
                      onBoarding = {true}
                      currentStep ={subStep}
                      handleNextStep ={nextSubStep}
                      getRedirectData={getRedirectData}
                    />
                </div>  
              </div>
            </Row>
        </div>
      </>
    )
  }

  const renderStep = () => {
    switch (step) {
      case 0:
        return renderStep0();
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      default:
        return null;
    }
  };

  

  return (
    <Fragment>
      <Loading
        mainContent =
        {
          !showLoader ? (
          <div className="bg-dark-shadow bg-animation h-100 onboarding-scroll">
            <Col md={12}>
              <Row className="mt-3 d-flex align-items-center">
                  <Col>
                    <div className="d-flex align-items-center justify-content-start ms-5">
                      {step > 0 && (
                        <span onClick={() => {prevStep()}} className="d-flex align-items-center cursor-pointer"><i class="fi fi-rr-arrow-left me-2"></i>Back</span>
                      )}
                    </div>
                  </Col>
                  {step === 2 && (
                      <Col md={8}>
                        <div className="d-flex justify-content-center align-items-center mx-auto ">
                          <span className={`separator-text d-flex align-items-center ${subStep >= 1 && 'complete-step-separator-text'}`}>
                          Create Account{subStep > 1 && (<i class="fi fi-ss-badge-check ms-1"></i>)}
                          </span>
                          <span className="separator"></span>                                       
                          {/* <span className={`separator-text d-flex align-items-center ${subStep >= 2 && 'complete-step-separator-text'}`}>
                            Sync Resources{subStep > 2 && (<i class="fi fi-ss-badge-check ms-1"></i>)}
                          </span> */}
                          <span className="separator"></span>
                          <span className={`separator-text d-flex align-items-center ${subStep  >= 3 && 'complete-step-separator-text'}`}>
                            Trial Settings{subStep > 3 && (<i class="fi fi-ss-badge-check ms-1"></i>)}
                          </span>
                        </div>
                      </Col>
                  )}
                  <Col>
                    <div className="d-flex align-items-center justify-content-end me-5">
                      {step === 2 && (
                        <span onClick={() => {onSkip()}} className="d-flex align-items-center cursor-pointer">Skip<i class="fi fi-rr-arrow-right ms-2"></i> </span>
                      )}
                    </div>
                  </Col>
              </Row>
              <Row className="mt-2">
                {renderStep()}
              </Row>
            </Col>
          </div>
          ) : (
            <div className="bg-dark-shadow bg-animation h-100 onboarding-scroll"></div>
          )
        }
        showLoader={
          showLoader
        }
      />
    </Fragment>
  )
}

export default Onboarding;